import React from 'react';

// import { IconButton, makeStyles, Theme } from '@material-ui/core';
// import Delete from '@material-ui/icons/Delete';
// import Edit from '@material-ui/icons/Edit';
import { IWithActionButtonProps } from '../../prop-types';
import ArrowUp from '../svg/ArrowUp';
import IconButton from './IconButton';
import ArrowDown from '../svg/ArrowDown';
import ArrowLeft from '../svg/ArrowLeft';
import ArrowRight from '../svg/ArrowRight';
import Add from '../svg/Add';
import Cancel from '../svg/Cancel';
import Delete from '../svg/Delete';
import Edit from '../svg/Edit';

interface IStandardIconsProps extends IWithActionButtonProps {
  onEditClick: () => void;
  onDeleteClick: () => void;
}

export default function StandardIcons({
  onEditClick,
  onDeleteClick,
  ...props
}: IStandardIconsProps) {
  return (
    <>
      <IconButton {...props.editButton} hideoutButton={true} onClick={onEditClick}>
        <Edit />
      </IconButton>
      <IconButton {...props.deleteButton} hideoutButton={true} onClick={onDeleteClick}>
        <Delete />
      </IconButton>
    </>
  );
}
